/*
 * @Author: Teemo Ding
 * @Date: 2021-10-09 13:11:50
 * @LastEditTime: 2022-06-13 17:35:19
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogistics/Components/ShippingRateTax.tsx
 */
import { Checkbox } from '@/src/components/Antd';
import { TaxApplyType } from '@/src/types/common/tax';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import TaxRules from 'src/constrains/TaxRules';
import styles from '../style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const ShippingRateTax = ({ disableEdit }: { disableEdit?: boolean }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Fragment>
      <Form.Item
        name='taxRulesEnabled'
        className={styles.taxRulesEnabled}
        valuePropName='checked'>
        <Checkbox disabled={disableEdit}>
          {getI18n('salesChannelLogistics.index.chargetaxonshippingrates')}
        </Checkbox>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(p, c) => p.taxRulesEnabled !== c.taxRulesEnabled}>
        {({ getFieldValue }: any) =>
          getFieldValue('taxRulesEnabled') && (
            <TaxRules applyTypes={[TaxApplyType.Shipping]} />
          )
        }
      </Form.Item>
    </Fragment>
  );
};

export default ShippingRateTax;
